import styled from 'styled-components';

export const StyledInfoTooltip = styled.div``;
